import { createFileRoute, Outlet, useRouterState } from "@tanstack/react-router";
import WorkflowDetailPage from "@/features/workflows/WorkflowDetailPage";
import { requireFeatureEnabled } from "@/features/features";

export const Route = createFileRoute("/_admin/workflows/$id")({
  beforeLoad: () => requireFeatureEnabled("workflows"),
  staticData: {
    // Until /workflows/$id has a real loader, render a generic label.
    // Page-side override (with workflow name) lands when the loader is wired.
    breadcrumb: { label: "Workflow detail" },
  },
  component: WorkflowDetailRouteShell,
});

export function WorkflowDetailRouteShell() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  if (pathname.includes("/runs/")) return <Outlet />;
  return <WorkflowDetailPage />;
}
